{
  "welcome_message": "{{name}}, раді вас бачити у Healthy Mind!",
  "welcome_returning_message": "{{name}}, раді вас бачити у Healthy Mind!",
  "description": "Це кілька простих кроків, щоб уважно подивитись на свій стан — без тиску й оцінок.",
  "description_returning": "Це кілька простих кроків, щоб уважно подивитись на свій стан — без тиску й оцінок.",
  "disclaimer": "⚠️Ваші відповіді та особисті дані залишаються тільки у вас.",

  "hmt_index": {
    "title": "Результати попередньої діагностики від {{date}}",
    "from_last_checkup": "з останнього чекапу {{date}}"
  },
  "recommendations": {
    "title": "Рекомендації для вашого стану",
    "description": "Прості кроки, які допоможуть стабілізувати стан — на основі останньої діагностики."
  },
  "call-to-action-card": {
    "button": "Пройти",
    "message": "Пройдіть опитування {{name}}",
    "sub-message": "Ми підготували невеликий тест, що визначає рівень шкали `{{scaleName}}`."
  },

  "task": {
    "default_strategy": {
      "onboarding": {
        "title": "Кілька слів про вас",
        "description": "Цей блок містить кілька загальних питань — про вік, освіту, сімейний стан тощо. Вони потрібні, щоб адаптувати подальшу діагностику до вашого досвіду.",
        "buttonText": "Розпочати"
      },
      "diagnostic": {
        "default": {
          "title": "Почати діагностику",
          "description": "Тут ви можете пройти повноцінний чекап, щоб сформувати загальну картину власного ментального стану і дізнатись які сфери є вашою опорою, а які потребують підтримки",
          "buttonText": "Почати",
          "timeDescription": "Цей крок займає в середньому 8 хвилин"
        },
        "withDelay": {
          "title": {
            "day": "Пройдіть діагностику через {{count}} ",
            "day_few": "Пройдіть діагностику через {{count}} дні",
            "day_many": "Пройдіть діагностику через {{count}} днів"
          },
          "description": "Повторний чекап допоможе побачити зміни у вашому стані — і зрозуміти, що для вас наразі актуально. Це спосіб тримати фокус на собі.",
          "buttonText": "Почати",
          "timeDescription": "Цей крок займає в середньому 8 хвилин"
        }
      },
      "results": {
        "hasResults": {
          "title": "Результати попередньої діагностики",
          "description": "Тут — ваші результати та підказки, що можуть стати в нагоді. Вони не дають остаточних відповідей — лише напрям, якщо захочете рухатись далі.",
          "buttonText": "Переглянути"
        },
        "default": {
          "title": "Тут будуть ваші результати",
          "description": "Тут — ваші результати та підказки, що можуть стати в нагоді. Вони не дають остаточних відповідей — лише напрям, якщо захочете рухатись далі.",
          "buttonText": "Переглянути"
        }
      },
      "hooksResults": {
        "title": "Результати додаткової діагностики",
        "description": "Тут зібрані результати, що стосуються окремих проявів вашого стану. Вони допоможуть краще зрозуміти ваші індивідуальні особливості, та актуальні потреби.",
        "buttonText": "Переглянути"
      }
    },

    "manual_strategy": {
      "onboarding": {
        "title": "Кілька слів про вас",
        "description": "Цей блок містить кілька загальних питань — про вік, освіту, рід занять тощо. Вони потрібні, щоб адаптувати подальшу діагностику до вашого досвіду.",
        "buttonText": "Розпочати"
      },
      "diagnostic": {
        "requsted": {
          "title": "Почати діагностику",
          "description": "Тут ви можете пройти повноцінний чекап, щоб сформувати загальну картину власного ментального стану і дізнатись які сфери є вашою опорою, а які потребують підтримки",
          "buttonText": "Почати",
          "timeDescription": "Цей крок займає в середньому 8 хвилин"
        },
        "default": {
          "title": "Діагностику ще не призначено",
          "description": "Чекап буде доступний, щойно менеджер надасть цю можливість.",
          "buttonText": "Почати",
          "timeDescription": "Цей крок займає в середньому 8 хвилин"
        }
      },
      "results": {
        "hasResults": {
          "title": "Результати попередньої діагностики",
          "description": "Тут — ваші результати та підказки, що можуть стати в нагоді. Вони не дають остаточних відповідей — лише напрям, якщо захочете рухатись далі.",
          "buttonText": "Переглянути"
        },
        "default": {
          "title": "Тут будуть ваші результати",
          "description": "Тут — ваші результати та підказки, що можуть стати в нагоді. Вони не дають остаточних відповідей — лише напрям, якщо захочете рухатись далі.",
          "buttonText": "Переглянути"
        }
      },
      "hooksResults": {
        "title": "Результати додаткової діагностики",
        "description": "Тут зібрані результати, що стосуються окремих проявів вашого стану. Вони допоможуть краще зрозуміти ваші індивідуальні особливості, та актуальні потреби.",
        "buttonText": "Переглянути"
      }
    }
  }
}
